import React from "react";
import RightTurnSvg from "./right-turn.svg";

interface RightTurnArrowProps {
    rotation?: number;
    count?: number;
    size?: number;
}

export const RightTurnArrow: React.FC<RightTurnArrowProps> = ({ rotation = 0, count, size = 60 }) => {
    return (
        <g transform={`rotate(${rotation})`}>
            <image href={RightTurnSvg} width={size} height={size} x={-size / 2} y={-size / 2} />
        </g>
    );
};
